<template>
  <a-row :gutter="24">
    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="出租方联系人1" prop="lessorContact">
            <a-input
              v-model="form.lessorContact"
              placeholder="请输入出租方联系人"
            />
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="出租方联系方式1" prop="lessorContactPhone">
            <a-input
              v-model="form.lessorContactPhone"
              placeholder="请输入出租方联系方式"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>

    <a-col :span="24">
      <a-row :gutter="24">
        <a-col :span="12">
          <a-form-model-item label="出租方联系人2">
            <a-input
              v-model="form.lessorContact2"
              placeholder="请输入出租方联系人"
            />
          </a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item label="出租方联系方式2">
            <a-input
              v-model="form.lessorContactPhone2"
              placeholder="请输入出租方联系方式"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-col>
  </a-row>
</template>

<script>
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
  },
};
</script>

<style>
</style>